// extracted by mini-css-extract-plugin
export default {"root":"ReturnButton_root__9KlGM","returnButtonIcon":"ReturnButton_returnButtonIcon__UIiSh","fullWidth":"ReturnButton_fullWidth__-gOi3","isMobile":"ReturnButton_isMobile__6Pitc"};